export default __webpack_public_path__ + "static/media/1_google_analytics.dde66732.svg";